import { http } from "@/api";
import { api } from "@/api";


const urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};

export const pushSupported = () =>
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;

export const enablePush = async () => {
    if (!pushSupported()) throw new Error("push not supported on this device");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("permission denied");
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        const res = await http.get("/push/vapid-public-key").then((r) => r.data);
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(res.key),
        });
    }
    const raw = sub.toJSON();
    await http.post("/push/subscribe", { endpoint: raw.endpoint, keys: raw.keys });
    return true;
};

export const disablePush = async () => {
    if (!pushSupported()) return;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
        const raw = sub.toJSON();
        await http.post("/push/unsubscribe", { endpoint: raw.endpoint, keys: raw.keys });
        await sub.unsubscribe();
    }
};

export const isSubscribed = async () => {
    if (!pushSupported()) return false;
    try {
        const reg = await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        return !!sub;
    } catch {
        return false;
    }
};

// Snooze helpers used by NagOverlay + others. `isos` (recurring only) snoozes specific beats
// via `occurrence_snoozes` instead of the whole task.
/** Recurring: snooze exactly the nagged SOURCE occurrence(s) via the atomic endpoint. */
export const snoozeTask = async (taskId, minutes = null, until = null, isos = null) => {
    if (isos?.length) {
        let doc = null;
        for (const iso of isos) doc = await http.post(`/tasks/${taskId}/occurrences/${iso}/snooze`, { minutes, until }).then((r) => r.data);
        return doc;
    }
    return http.post(`/tasks/${taskId}/snooze`, { minutes, until }).then((r) => r.data);
};
